import { createFileRoute } from '@tanstack/react-router';
import { JourneysAutomationTestsHandoff } from '@/pages/workspaces/automations/[campaignId]/tests/routing';
import { campaignExperimentRedirect } from './-campaign-experiment-redirects';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/tests',
)({
  component: JourneysAutomationTestsHandoff,
  beforeLoad: campaignExperimentRedirect(),
});
